<template>
  <div class="modal right fade" :id="objectModalName.sharedResponsibility" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.sharedResponsibility)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.sharedResponsibility)">×</button>
          <div class="row w-100">
            <div class="col-md-7 account d-flex">
              <div class="company_img">
                <img src="@/assets/img/c-logo.png" alt="User" class="img-fluid" />
              </div>
              <div>
                <p class="mb-0">Gemeinsame Verantwortung </p>
                <span class="modal-title">{{currentSharedResponsibility.processor}}</span>
                <a href="#" @click.prevent="setEdit(!edit)"><span class="lock"><i class="fa fa-pencil" aria-hidden="true" v-show="!edit"></i><i class="fa fa-lock" aria-hidden="true" v-show="edit"></i></span></a>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <p class="mt-2 mb-1 text-muted">Welche personenbezogenen Daten werden erhoben?<span class="text-danger">*</span></p>
                  <h4 class="mt-0" v-if="currentSharedResponsibility.id && !edit">{{currentSharedResponsibility.data_type}}</h4>
                  <div v-show="!currentSharedResponsibility.id || edit">
                    <select class="form-control select select-data-type allow-create" v-model="currentSharedResponsibility.data_type" v-select2>
                      <option v-for="dataType in dataTypes" :key="dataType.id" :value="dataType.id">{{dataType.text}}</option>
                    </select>
                    <span class="error-message text-danger" v-show="v$.currentSharedResponsibility.data_type.$errors.length>0">{{ $t('required_field') }}</span>
                  </div>

                  <div class="row mt-2">
                    <div class="col-12">
                      <!-- start due date -->
                      <p class="mt-2 mb-1 text-muted">Wer verarbeitet die pbD?<span class="text-danger">*</span></p>
                      <div class="d-flex">
                        <i class='uil uil-schedule text-success me-1'></i>
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSharedResponsibility.id && !edit">{{currentSharedResponsibility.processor}}</h5>
                          <textarea class="form-control" v-if="!currentSharedResponsibility.id || edit" v-model="currentSharedResponsibility.processor" autocomplete="off"></textarea>
                          <span class="error-message text-danger" v-show="v$.currentSharedResponsibility.processor.$errors.length>0">{{ $t('required_field') }}</span>
                        </div>
                      </div>
                      <!-- end due date -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->


                  <div class="row mt-2">
                    <div class="col-6">
                      <!-- start due date -->
                      <p class="mt-2 mb-1 text-muted">Wie werden die pbD verarbeitet?<span class="text-danger">*</span></p>
                      <div class="d-flex">
                        <i class='uil uil-schedule text-success me-1'></i>
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSharedResponsibility.id && !edit">{{currentSharedResponsibility.how}}</h5>
                          <textarea class="form-control" v-if="!currentSharedResponsibility.id || edit" v-model="currentSharedResponsibility.how" autocomplete="off"></textarea>
                        </div>
                      </div>
                      <!-- end due date -->
                    </div> <!-- end col -->
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt- mb-1 text-muted">Zweck und Rechtsgrundlage der Verarbeitung.</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSharedResponsibility.id && !edit">{{currentSharedResponsibility.legal_base}}</h5>
                          <textarea class="form-control" v-if="!currentSharedResponsibility.id || edit" v-model="currentSharedResponsibility.legal_base" placeholder="Zweck und Rechtsgrundlage der Verarbeitung." autocomplete="off"></textarea>
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->

                  <div class="row mt-2">
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt-2 mb-1 text-muted">Wo werden die Daten gespeichert?<span class="text-danger">*</span></p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSharedResponsibility.id && !edit">{{currentSharedResponsibility.storage_place}}</h5>
                          <input class="form-control" v-if="!currentSharedResponsibility.id || edit" v-model="currentSharedResponsibility.storage_place" placeholder="Wo werden die Daten gespeichert?" autocomplete="off" />
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt-2 mb-1 text-muted">Wer übernimmt die Betroffenenrechte?</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSharedResponsibility.id && !edit">{{currentSharedResponsibility.informer}}</h5>
                          <input class="form-control" v-if="!currentSharedResponsibility.id || edit" v-model="currentSharedResponsibility.informer" placeholder="Wer übernimmt die Betroffenenrechte?" autocomplete="off" />
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->

                  <div class="row mt-2">
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt- mb-1 text-muted">Wer stellt die Löschung sicher?</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSharedResponsibility.id && !edit">{{currentSharedResponsibility.deleter}}</h5>
                          <textarea class="form-control" v-if="!currentSharedResponsibility.id || edit" v-model="currentSharedResponsibility.deleter" placeholder="Wer stellt die Löschung sicher?" autocomplete="off"></textarea>
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt-2 mb-1 text-muted">Wer übernimmt die Meldung von Datenpannen?</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSharedResponsibility.id && !edit">{{currentSharedResponsibility.responser}}</h5>
                          <textarea class="form-control" v-if="!currentSharedResponsibility.id || edit" v-model="currentSharedResponsibility.responser" placeholder="Wer übernimmt die Meldung von Datenpannen?" autocomplete="off"></textarea>
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->
                  <div class="row mt-2">
                    <div class="col-12">
                      <!-- assignee -->
                      <p class="mt- mb-1 text-muted">Bemerkungen</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentSharedResponsibility.id && !edit">{{currentSharedResponsibility.remarks}}</h5>
                          <textarea class="form-control" v-if="!currentSharedResponsibility.id || edit" v-model="currentSharedResponsibility.remarks" placeholder="Bemerkungen" autocomplete="off"></textarea>
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->

                  <!-- start attachments -->
                  <slot name="fileUpload"></slot>
                  <!-- end attachments -->
                  <!-- comments -->
                  <slot name="comments"></slot>
                  <!-- end comments -->
                </div> <!-- end col -->
              </div> <!-- end row-->
            </div> <!-- end card-body -->
          </div>
        </div>
        <div class="modal-footer" v-if="!currentSharedResponsibility.id || edit">
          <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click.prevent="saveSharedResponsibility" :key="btnEnableKey" :disabled="btnDisabled">Speichern</button>&nbsp;&nbsp;
          <button type="button" class="btn btn-secondary btn-rounded" @click="closeWarning('#'+objectModalName.sharedResponsibility)">Abbrechen</button>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>

<script>
import {service} from '@/utils/request.js';
import {ajaxErrorMessage, closeWarning, initSelect2} from '@/utils/index.js';
import { objectModalName } from '@/utils/enums.js';
import {mapState, mapMutations} from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  name: "SharedResponsibilityComponent",
  props: {
    currentSharedResponsibility: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      objectModalName: objectModalName,
      btnEnableKey: 1,
      btnDisabled: false,
    }
  },
  mounted() {
    initSelect2()
    $('#'+objectModalName.sharedResponsibility).on('hidden.bs.modal', () => {
      this.setEdit(false)
    })
  },
  beforeDestroy() {
    $('#'+objectModalName.sharedResponsibility).off('hidden.bs.modal')
  },
  computed: {
    ...mapState({
      accountid: state => state.account.accountid,
      userName: state => state.user.username,
      account: state => state.account,
      userID: state => state.user.id,
      edit: state => state.app.edit,
      dataTypes: state => state.account.dataTypes,
      modalDirty: state => state.app.modalDirty,
    }),
  },
  validations() {
    return {
      currentSharedResponsibility: {
        data_type: {required, $lazy: true},
        processor: {required, $lazy: true},
      },
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  watch:{
    currentSharedResponsibility: {
      handler: function (newValue, oldVal) {
        if (!this.modalDirty) this.setModalDirty(true)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
    closeWarning,
    async saveSharedResponsibility() {
      if (this.currentSharedResponsibility.customer === '') this.currentSharedResponsibility.customer = this.account.name
      if (!this.currentSharedResponsibility.modified_by) this.currentSharedResponsibility.modified_by = this.userName
      const isValid = await this.v$.currentSharedResponsibility.$validate()
      if (!isValid) {
        this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
        return
      }
      this.btnDisabled = true
      let url = 'todos/v1/create_shared_responsibility/'
      let newSharedResponsibility = true
      if (this.currentSharedResponsibility.id) {
        url = `todos/v1/update_shared_responsibility/${this.currentSharedResponsibility.id}/`
        newSharedResponsibility = false
      }
      service.request({
        url: url,
        method: 'POST',
        responseType: 'json',
        data: this.currentSharedResponsibility
      }).then((response) => {
        this.setModalDirty(false)
        this.v$.$reset()
        this.btnDisabled = false
        this.$emit('sharedResponsibilityUpdated', response.data)
        $('#' + this.objectModalName.sharedResponsibility).modal('hide')
        this.$vToastify.success('Gemeinsame Verantwortung ist erfolgreich gespeichert!')
      }).catch(error => {
        this.btnDisabled = false
        this.$vToastify.error(ajaxErrorMessage(error))
      })
    },
  }
}
</script>

<style scoped>
.close {
  right: 25px;
  top: 20px;
}
</style>
